import { GraphQL } from '@guestgoodie/graphql'
import { HugeiconsIcon } from '@hugeicons/react'
import { useLingui } from '@lingui/react/macro'

import {
  Delete02Icon,
  DragDropVerticalIcon,
  PencilEdit01Icon
} from '@hugeicons/core-solid-rounded'

import ConfirmDialog from '@/components/ui/ConfirmDialog'
import UpDownButtons from './UpDownButtons'

export default function CategoryButtons({
  category,
  onEdit,
  onRemove,
  onUp,
  onDown,
  dragHandleRef
}: {
  category: GraphQL.CategoryFragmentFragment
  onEdit: () => void
  onRemove: () => void
  onUp: () => void
  onDown: () => void
  dragHandleRef: React.RefObject<HTMLDivElement | null>
}) {
  const { t } = useLingui()

  const categoryName = category.name

  return (
    <div className="flex flex-col justify-between p-1">
      <div className="flex flex-col gap-1">
        <div
          className="size-5 cursor-grab rounded-[5px] text-text hover:bg-primary-bright"
          ref={dragHandleRef}
        >
          <HugeiconsIcon icon={DragDropVerticalIcon} className="size-full" />
        </div>
        <UpDownButtons onUp={onUp} onDown={onDown} />
      </div>
      <div className="flex flex-col gap-2">
        <button
          className="size-5 text-text"
          aria-label={t`Edit category`}
          tabIndex={0}
          onClick={onEdit}
        >
          <HugeiconsIcon icon={PencilEdit01Icon} className="size-full" />
        </button>
        <ConfirmDialog
          title={t`Delete category`}
          message={t`Are you sure you want to delete the category with the name "${categoryName}"?`}
          onConfirm={onRemove}
        >
          <div className="size-5 text-text" aria-label={t`Delete category`}>
            <HugeiconsIcon icon={Delete02Icon} className="size-full" />
          </div>
        </ConfirmDialog>
      </div>
    </div>
  )
}
